import React, { useEffect, useRef } from 'react';
import { gsap } from 'gsap';

const ContactDetails = ({ data }) => {
  const sectionRef = useRef(null);

  useEffect(() => {
    gsap.from(sectionRef.current, {
      duration: 0.4,
      delay: 0.6,
      opacity: 0,
      yPercent: 20,
      force3D: true,
    });
  }, []);

  return (
    <section ref={sectionRef} className="contact-details">
      <div className="container">
        <div className="row">
          <div className="col-md-3 mb-6 mb-md-0 pr-lg-10">
            <h4 className="text-headline pb-4 mb-4 pb-md-5 mb-md-5">Address</h4>
            {data.addresses.map(item => (
              <p className="mb-3" key={item.address}>
                <a
                  className="d-inline-flex align-items-start text-black"
                  href="https://www.google.com/maps/place/BG+Steel/@42.7403944,23.2363083,17z/data=!4m13!1m7!3m6!1s0x40aa90963ba27cc3:0x4a6afdac524a16d5!2sbul.+%22Evropa%22+174,+1331+Republika,+Sofia!3b1!8m2!3d42.7403944!4d23.238497!3m4!1s0x40aa8494f72f98ab:0xcbac99d909cdc2ae!8m2!3d42.7419833!4d23.2360726"
                >
                  <i className="far fa-map-marker-alt mr-3"></i>
                  {item.address}
                </a>
              </p>
            ))}
          </div>

          <div className="col-md-3 mb-6 mb-md-0 pr-lg-10">
            <h4 className="text-headline pb-4 mb-4 pb-md-5 mb-md-5">Phone</h4>

            {data.phones.map(item => (
              <p className="mb-3" key={item.phone}>
                <a
                  className="d-inline-flex align-items-center text-black"
                  href={`tel:${item.phone}`}
                >
                  <i className="far fa-phone-alt mr-3"></i>
                  {item.phone}
                </a>
              </p>
            ))}
          </div>

          <div className="col-md-3 mb-6 mb-md-0 pr-lg-10">
            <h4 className="text-headline pb-4 mb-4 pb-md-5 mb-md-5">Email</h4>

            {data.emails.map(item => (
              <p className="mb-3" key={item.email}>
                <a
                  className="d-inline-flex align-items-center text-black"
                  href={`mailto:${item.email}`}
                >
                  <i className="far fa-envelope mr-3"></i>
                  {item.email}
                </a>
              </p>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default ContactDetails;
